import React from 'react';
import { Avatar } from '../Avatar/Avatar';

interface UserListAvatarProps {
  userId: number;
  userName: string;
  userPicture?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (userId: number) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
}

export const UserListAvatar: React.FC<UserListAvatarProps> = React.memo(({
  userId,
  userName,
  userPicture,
  className,
  style,
  onClick,
  size = 'medium'
}) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(userId);
    }
  }, [onClick, userId]);

  return (
    <Avatar
      name={userName}
      picture={userPicture}
      className={`${className || ''} ${size}`}
      style={style}
      onClick={handleClick}
    />
  );
});

UserListAvatar.displayName = 'UserListAvatar';